export default __webpack_public_path__ + "static/media/lang_he.ce02b77a.svg";